import { render, staticRenderFns } from "./compose-message-btn.vue?vue&type=template&id=7460841d&"
import script from "./compose-message-btn.vue?vue&type=script&lang=js&"
export * from "./compose-message-btn.vue?vue&type=script&lang=js&"
import style0 from "./compose-message-btn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports